import { defineStore } from "pinia";
import objectStorage from "@/lib/objectStorage/objectStorage.js";
import tools from "@/utils/tools.js";
import ffmpegUtil from "@/components/media/utils/ffmpegUtil.js";
import clipUtil from "@/components/media/utils/clipUtil.js";

const useCoverVoiceCustomSingerDataStore = defineStore({
  id: "coverVoiceCustomSingerDataStore",
  state: () => {
    return {
        fileDatas:{

        }, 
        fileDatasMap:{

        }
    }
  },
  fileData: {
    addFileData(fileData){
      this.fileDatas.push(fileData);
      this.fileDatasMap[fileData.uuid] = fileData;
    },
    removeFileData(fileData){
      this.fileDatas = this.fileDatas.filter(item => item !== fileData);
      delete this.fileDatasMap[fileData.uuid];
    },
    updateFileData(fileData){
      Object.assign(this.fileDatasMap[fileData.uuid], fileData);
    },
    doUploadFileData(fileData){
      
    },
    doSaveFileData(fileData){ 
      
    }
  }
})

export default useCoverVoiceCustomSingerDataStore;